<template>
  <div>
    <van-field
      v-for="(item, index) in list"
      :key="index"
      :value='data[item.field]'
      center
      label-width="100"
      :type="item.type"
      :label="item.label"
      :placeholder="item.placeholder"
      @input="handleChange($event,item.field)"
    >
    <template #button>
      <i v-if="show === '1'" class="huisuiyunfont ok">{{'\ue614'}}</i>
    </template>
    </van-field>
  </div>
</template>
<script>
import { Field } from 'vant'
export default {
  data () {
    return {

    }
  },
  methods: {
    handleChange (e, field) {
      this.$emit('onChange', { e: e, field: field })
    }
  },
  props: {
    list: {
      type: [Object, Array]
    },
    data: {
      type: Object
    },
    onInputChange: {
      type: Function
    },
    show: {
      type: String
    }
  },
  components: {
    [Field.name]: Field
  }
}
</script>
<style scoped>
  .ok{
    color: #1BC6E0;
    font-size: 47px;
    vertical-align: middle;
  }
  .no{
    color: #FF6947;
    font-size: 47px;
  }
</style>
